import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e9f1a20"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "vehicle-detail"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DescriptionList = _resolveComponent("DescriptionList")!

  return (_ctx.id && _ctx.detail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_DescriptionList, {
          title: '车辆情况',
          data: _ctx.detail,
          list: _ctx.description,
          collapse: _ctx.collapse,
          onCollapse: _ctx.onCollapseChange
        }, null, 8, ["data", "list", "collapse", "onCollapse"])
      ]))
    : _createCommentVNode("", true)
}